import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id D0AEFF89-C011-4445-B685-A1366099D920
 * name radio-am
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radio-am.svg
 * tags
 * - Audio 
 */
export const RadioAmIcon = createSvgIcon(<><path d="M5,7A2,2 0 0,0 3,9V17H5V13H7V17H9V9A2,2 0 0,0 7,7H5M5,9H7V11H5V9M13,7A2,2 0 0,0 11,9V17H13V9H15V16H17V9H19V17H21V9A2,2 0 0,0 19,7H13Z" /></>, 'RadioAmIcon');
export default RadioAmIcon